<template>
  <section>
    <template v-if="![460, 526, 557, 933].includes(userId)">
    <div class="container-files-kcp">
      <div class="container-files-kcp__title">
        <template v-if="newRegions">Приложение к приказу от&nbsp;«28» декабря 2024 г. № 983</template>
        <a v-else href="https://files.ined.ru/files/kcp2025/prikaz_kcp_bsm.pdf">Приложение к приказу от&nbsp;«28» декабря 2024 г. № 985</a>
      </div>
      <div>
        <div class="d-flex justify-space-between mb-2">
          <v-btn v-if="statusOrg.numBsmAccred !== null" class="success__v-btn"
                 @click="downloadFilePril({orgId: statusOrg.orgId, prilNum: newRegions ? 7: 1})"
               :loading="downloadingFileToServer.value">Контрольные цифры приема по программам бакалавриата, программам специалитета, программам магистратуры, имеющим государственную аккредитацию</v-btn>
          <span v-else>Контрольные цифры приема по программам бакалавриата, программам специалитета, программам магистратуры, имеющим государственную аккредитацию не распределены</span>
        </div>
        <div class="d-flex justify-space-between mb-2">
          <v-btn v-if="statusOrg.numBsmNeacred !== null" class="success__v-btn"
                 @click="downloadFilePril({orgId: statusOrg.orgId, prilNum: newRegions ? 8: 2})"
               :loading="downloadingFileToServer.value">Контрольные цифры приема по программам бакалавриата, программам специалитета, программам магистратуры, не имеющим государственную аккредитацию</v-btn>
          <span v-else>Контрольные цифры приема по программам бакалавриата, программам специалитета, программам магистратуры, не имеющим государственную аккредитацию не распределены</span>
        </div>
      </div>
    </div>
    <v-divider class="my-4"/>
    <div class="container-files-kcp">
      <div class="container-files-kcp__title">
        <template v-if="newRegions">Приложение к приказу от&nbsp;«28» декабря 2024 г. № 984</template>
        <a v-else href="https://files.ined.ru/files/kcp2025/prikaz_kcp_aoa.pdf">Приложение к приказу от&nbsp;«28» декабря 2024 г. № 986</a>
      </div>
      <div>
        <div class="d-flex justify-space-between mb-2">
          <v-btn v-if="statusOrg.numOaAccred !== null" class="success__v-btn"
               @click="downloadFilePril({orgId: statusOrg.orgId, prilNum: newRegions ? 9: 3})"
               :loading="downloadingFileToServer.value">Контрольные цифры приема по программам ординатуры, программам ассистентуры-стажировки, имеющим государственную аккредитацию</v-btn>
          <span v-else>Контрольные цифры приема по программам ординатуры, программам ассистентуры-стажировки, имеющим государственную аккредитацию не распределены</span>
        </div>
        <div class="d-flex justify-space-between mb-2" v-if="!newRegions">
          <v-btn v-if="statusOrg.numOaNeacred !== null" class="success__v-btn"
                 @click="downloadFilePril({orgId: statusOrg.orgId, prilNum: 5})"
               :loading="downloadingFileToServer.value">Контрольные цифры приема по программам ординатуры, программам ассистентуры-стажировки, не имеющим государственную аккредитацию</v-btn>
          <span v-else>Контрольные цифры приема по программам ординатуры, программам ассистентуры-стажировки, не имеющим государственную аккредитацию не распределены</span>
        </div>
        <div class="d-flex justify-space-between mb-2">
          <v-btn v-if="statusOrg.numAsp !== null" class="success__v-btn"
                 @click="downloadFilePril({orgId: statusOrg.orgId, prilNum: newRegions ? 10 : 4})"
               :loading="downloadingFileToServer.value">Контрольные цифры приема по программам научно-педагогических кадров в аспирантуре</v-btn>
          <span v-else>Контрольные цифры приема по программам научно-педагогических кадров в аспирантуре не распределены</span>
        </div>
        <div class="d-flex justify-space-between mb-2" v-if="statusOrg.numIntern !== null && !newRegions">
          <v-btn v-if="statusOrg.numIntern !== null" class="success__v-btn"
                 @click="downloadFilePril({orgId: statusOrg.orgId, prilNum: 6})"
               :loading="downloadingFileToServer.value">Контрольные цифры приема по программам интернатуры, имеющим государственную аккредитацию</v-btn>
          <span v-else>Контрольные цифры приема по программам интернатуры, имеющим государственную аккредитацию не распределены</span>
        </div>
      </div>
    </div>
    </template>
    <template v-else>
      <div class="container-files-kcp">
        <div>
          <div class="d-flex justify-space-between mb-2">
            <v-btn v-if="statusOrg.numBsmAccred !== null" class="success__v-btn"
                   @click="downloadFilePril({orgId: statusOrg.orgId, prilNum: 1})"
                   :loading="downloadingFileToServer.value">Приложение №{{ statusOrg.numBsmAccred }} к распоряжению Министерства науки и высшего образования Российской Федерации от&nbsp;«27» декабря 2024 г. № 514-р</v-btn>
            <span v-else>Контрольные цифры приема по программам бакалавриата, программам специалитета, программам магистратуры, имеющим государственную аккредитацию не распределены</span>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import {setFileFunctions} from "@/mixins/fileFucntions";
import {mapGetters} from "vuex";

export default {
  name: "ContainerKCPInformationDocuments",
  mixins: [setFileFunctions],
  props: {
    statusOrg: Object
  },
  data() { return {
    loadingFile1: false,
    loadingFile2: false,
    loadingFile3: false,
    loadingFile4: false,
    loadingFile5: false,
    loadingFile6: false,
  }},
  computed: {
    ...mapGetters('spr', {getOrgs: 'getOrgs'}),
    ...mapGetters('keycloak', {userId: 'userId'}),
    newRegions() {
      if (this.currentStage === 8) return false;
      const x = this.getOrgs?.find(el => el.id === this.userId);
      return [94, 95, 96, 97].includes(x?.region?.id)
    }
  }
}
</script>

<style lang="sass">
.container-files-kcp
  display: flex
  flex-direction: row
  align-items: center

  &__title
    display: flex
    flex-direction: row
    flex-basis: 300px
    min-width: 300px
    margin-right: 10px

.info-card__button
  margin-top: 10px
  margin-left: 10px

.file-edit
  display: flex
  align-items: center

.file-edit .v-file-input
  max-width: 300px
  margin-right: 10px
  min-width: 200px

.file-edit
  display: inline-flex
  align-items: center
  background: #FFEDE2
  padding: 0 15px
  border-radius: 10px
  margin: 20px

.border_margin_right
  margin-right: 10px
</style>